import classNames from 'classnames';

export const Divider = ({ className = 'h-[10px]' }: { className?: string }) => (
  <div className={classNames(`border-b border-cf-gray-4`, className)} />
);
